import {Component, inject, input, InputSignal, ChangeDetectionStrategy} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {ICONS} from '../../constants/icons/icons.constants';
import {AiChatService} from '../../services/ai/ai-chat.service';
import {AppService} from '../../services/app/app.service';
import {ButtonComponent} from '../buttons/button/button.component';
import {TranslatePipe} from '@ngx-translate/core';
import {AppButtonTypeEnum} from '../../enums/button/app-button-type.enum';

@Component({
    selector: 'app-history-button',
    templateUrl: './history-button.component.html',
    styleUrls: ['./history-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        TranslatePipe,
    ]
})
export class HistoryButtonComponent {
    public customHistoryBackAction: InputSignal<(() => void) | undefined> = input();
    public isHistoryCloseButton: InputSignal<boolean> = input(false);
    protected readonly ICONS = ICONS;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    private readonly aiChatService = inject(AiChatService);
    private readonly appService = inject(AppService);
    private readonly navigationService = inject(NavigationService);

    protected closeHistory(): void {
        this.appService.hideHistoryOverlay();
    }

    protected showHistoryOverlay(): void {
        this.appService.showHistoryOverlay();
    }

    protected async goBackInHistory(): Promise<void> {
        const customHistoryBackAction = this.customHistoryBackAction();
        if (customHistoryBackAction) {
            customHistoryBackAction();
            return;
        }

        // Don't go back in history if aiChatOverlay is shown. Simply hide the chat overlay.
        if (this.aiChatService.getIsShowingAiChat()) {
            await this.aiChatService.hideAiChatOverlay();
            return;
        }

        this.navigationService.goBackInHistory();
    }
}
